import React, { useState, useEffect, useRef } from 'react';
import InputMask from 'react-input-mask';
import { Popup} from 'semantic-ui-react';
import { isValidForm, updateDataToObj } from '..';
import { isPatternValid } from '../../../_utilities/validation';
import { IBankAccount, IBankAccountValidation, IContact, IContactValidation, IForm, IFormValidation } from '../types';

export const StepTwo = (props) => {

    const { inputData, saveData, nextStep, validationData, saveValidationData } = props
    const [outputData, setOutputData] = useState<IForm>(inputData);
    const [valData, setValData] = useState<IFormValidation>(validationData);
    const [isValid, setIsValid] = useState<boolean>(false);


    const inputChange = (path, value, index = -1, extraKey = '') => {
        const tempData = updateDataToObj(outputData, path, value, index, extraKey);
        setOutputData({ ...tempData });
    }

    const inputBlur = (element, path, index = -1, extraKey = '') => {
        const tempVal = updateDataToObj(valData, path, isPatternValid(element.getAttribute('data-pattern'), element.value), index, extraKey);
        setValData({ ...tempVal });
    }

    const addBillingEmail = () => {
        let tempData: IForm = outputData;
        tempData.billingData.billingEmails.push('');
        setOutputData({ ...tempData });

        let tempVal: IFormValidation = valData;
        tempVal.billingData.billingEmails.push(undefined);
        setValData({ ...tempVal });
    }

    const removeBillingEmail = () => {
        let tempData: IForm = outputData;
        tempData.billingData.billingEmails.pop();
        setOutputData({ ...tempData });

        let tempVal: IFormValidation = valData;
        tempVal.billingData.billingEmails.pop();
        setValData({ ...tempVal });
    }

    const addBankAccount = () => {
        let tempData: IForm = outputData;
        const newAccount: IBankAccount = {
            "bankName": "",
            "bankAccountNumber": ""
        }
        tempData.billingData.bankAccounts.push(newAccount);
        setOutputData({ ...tempData });

        let tempVal: IFormValidation = valData;
        const newAccountValidation: IBankAccountValidation = {
            "bankName": undefined,
            "bankAccountNumber": undefined
        }
        tempVal.billingData.bankAccounts.push(newAccountValidation);
        setValData({ ...tempVal });
    }

    const removeBankAccount = () => {
        let tempData: IForm = outputData;
        tempData.billingData.bankAccounts.pop();
        setOutputData({ ...tempData });

        let tempVal: IFormValidation = valData;
        tempVal.billingData.bankAccounts.pop();
        setValData({ ...tempVal });
    }

    const addContact = () => {
        let tempData: IForm = outputData;
        const newContact: IContact = {
            "contactName": "",
            "contactPhone": "",
            "contactEmail": "",
        }
        tempData.contactDetails.push(newContact);
        setOutputData({ ...tempData });

        let tempVal: IFormValidation = valData;
        const newContactValidation: IContactValidation = {
            "contactName": undefined,
            "contactPhone": undefined,
            "contactEmail": undefined
        }
        tempVal.contactDetails.push(newContactValidation);
        setValData({ ...tempVal });
    }

    const removeContact = () => {
        let tempData: IForm = outputData;
        tempData.contactDetails.pop();
        setOutputData({ ...tempData });

        let tempVal: IFormValidation = valData;
        tempVal.contactDetails.pop();
        setValData({ ...tempVal });
    }


    useEffect(() => {
        setIsValid(isValidForm(formRef.current))
    }, [outputData, valData]);

    const formRef = useRef(null);
    const formSubmit = (e) => {
        e.preventDefault();
        saveData({ ...outputData });
        saveValidationData({ ...valData });
        nextStep(3);
    }

    return <div className="m-form__step">

        <h2 className="m-form__header">Dane do rozliczeń i kontaktu</h2>
        <form onSubmit={formSubmit} ref={formRef}>
            <div className="m-form__block">
                <h3 className="m-form__subheader">
                    Dane do wysyłki faktur i dokumentów rozliczeniowych
                </h3>
                {outputData.billingData.billingEmails.map((email, index) => (
                    <div className="m-form__group" key={'email' + index}>
                        <div className={`m-form__field ${valData.billingData.billingEmails[index] == false ? 'is--error' : ''}`}>
                            <label className="with-tooltip">E-mail</label>
                            <div className="m-form__component">
                                <input
                                    type='email'
                                    placeholder="Adres mailowy, na który będą wysyłane Dokumenty Księgowe"
                                    data-pattern="[\w-\.]+@([\w-]+\.)+[\w-]{2,4}"
                                    data-required
                                    // name='billingData.billingEmails'
                                    value={email}
                                    onChange={(e) => {
                                        inputChange('billingData.billingEmails', e.target.value, index);
                                    }}
                                    onBlur={(e) => {
                                        inputBlur(e.target, 'billingData.billingEmails', index);
                                    }}
                                />
                            </div>
                            <div className="m-form__component-error">
                                {outputData.billingData.billingEmails[index] == '' ? 'Proszę uzupełnić pole' : 'Prosze poprawić pole'}
                            </div>
                        </div>
                    </div>
                )
                )}
                {outputData.billingData.billingEmails.length < 3 && <button type="button" className="m-form__btn m-form__btn--light" onClick={addBillingEmail} ><span>+ Dodaj kolejny adres email</span> (opcjonalnie)</button>}
                {outputData.billingData.billingEmails.length > 1 && <button type="button" className="m-form__btn m-form__btn--light" onClick={removeBillingEmail} ><span>- Usuń ostatni adres email</span></button>}
            </div>

            <div className="m-form__block">
                <h3 className="m-form__subheader with-tooltip">
                    <span>Dane bankowe wnioskującego</span>
                    <Popup content='Podane dane będą używane do rozliczeń' trigger={<i className="icon-info"></i>} />
                </h3>
                {outputData.billingData.bankAccounts.map((bank, index) => (
                    <div className="m-form__group" key={'bank' + index}>
                        <div className={`m-form__field ${valData.billingData.bankAccounts[index].bankName == false ? 'is--error' : ''}`}>
                            <label className="with-tooltip">Nazwa banku</label>
                            <div className="m-form__component">
                                <input
                                    type='text'
                                    placeholder="Nazwa Banku w którym prowadzony jest rachunek wskazany poniżej"
                                    data-pattern="^.{1,64}$"
                                    data-required
                                    // name=''
                                    value={bank.bankName}
                                    onChange={(e) => {
                                        inputChange('billingData.bankAccounts', e.target.value, index, 'bankName');
                                    }}
                                    onBlur={(e) => {
                                        inputBlur(e.target, 'billingData.bankAccounts', index, 'bankName');
                                    }}
                                />
                            </div>
                            <div className="m-form__component-error">
                                {outputData.billingData.bankAccounts[index].bankName == '' ? 'Proszę uzupełnić pole' : 'Prosze poprawić pole'}
                            </div>
                        </div>
                        <div className={`m-form__field ${valData.billingData.bankAccounts[index].bankAccountNumber == false ? 'is--error' : ''}`}>
                            <label className="with-tooltip">
                                <span>Numer rachunku PLN</span>
                                <Popup content='Służy do identyfikowania wpłaty klienta, automatycznego księgowania i rozliczania należności.' trigger={<i className="icon-info"></i>} />
                            </label>
                            <div className="m-form__component">
                                <InputMask
                                    mask='PL99 9999 9999 9999 9999 9999 9999'
                                    placeholder="Rachunek z którego będą opłacane Dokumenty Rozliczeniowe"
                                    data-required
                                    data-pattern="IBAN"
                                    // name=''
                                    value={bank.bankAccountNumber}
                                    onChange={(e) => {
                                        inputChange('billingData.bankAccounts', e.target.value, index, 'bankAccountNumber');
                                    }}
                                    onBlur={(e) => {
                                        inputBlur(e.target, 'billingData.bankAccounts', index, 'bankAccountNumber');
                                    }}
                                />
                            </div>
                            <div className="m-form__component-error">
                                {outputData.billingData.bankAccounts[index].bankAccountNumber == '' ? 'Proszę uzupełnić pole' : 'Prosze poprawić pole'}
                            </div>
                        </div>
                    </div>
                )
                )}
                {outputData.billingData.bankAccounts.length < 3 && <button type="button" className="m-form__btn m-form__btn--light" onClick={addBankAccount} ><span>+ Dodaj kolejny Bank</span> (opcjonalnie)</button>}
                {outputData.billingData.bankAccounts.length > 1 && <button type="button" className="m-form__btn m-form__btn--light" onClick={removeBankAccount} ><span>- Usuń ostatni Bank</span></button>}
            </div>

            <div className="m-form__block">
                <h3 className="m-form__subheader with-tooltip">
                    <span>Dane kontaktowe</span>
                    <Popup content='Dane do bieżącego kontaktu' trigger={<i className="icon-info"></i>} />
                </h3>
                {outputData.contactDetails.map((contact, index) => (
                    <div className="m-form__group" key={'contact' + index}>
                        <div className={`m-form__field ${valData.contactDetails[index].contactName == false ? 'is--error' : ''}`}>
                            <label className="with-tooltip">Imię i nazwisko</label>
                            <div className="m-form__component">
                                <input
                                    type='text'
                                    placeholder=""
                                    data-pattern="^.{1,64}$"
                                    data-required
                                    // name={contact}
                                    value={contact.contactName}
                                    onChange={(e) => {
                                        inputChange('contactDetails', e.target.value, index, 'contactName');
                                    }}
                                    onBlur={(e) => {
                                        inputBlur(e.target, 'contactDetails', index, 'contactName');
                                    }}
                                />
                            </div>
                            <div className="m-form__component-error">
                                {outputData.contactDetails[index].contactName == '' ? 'Proszę uzupełnić pole' : 'Prosze poprawić pole'}
                            </div>
                        </div>
                        <div className={`m-form__field ${valData.contactDetails[index].contactPhone == false ? 'is--error' : ''}`}>
                            <label className="with-tooltip">Numer telefonu</label>
                            <div className="m-form__component">
                                <InputMask
                                    mask='48999999999'
                                    placeholder=''
                                    data-required
                                    data-pattern="\d{11}"
                                    // name='contact.contactPhone'
                                    value={contact.contactPhone}
                                    onChange={(e) => {
                                        inputChange('contactDetails', e.target.value, index, 'contactPhone');
                                    }}
                                    onBlur={(e) => {
                                        inputBlur(e.target, 'contactDetails', index, 'contactPhone');
                                    }}
                                />
                            </div>
                            <div className="m-form__component-error">
                                {outputData.contactDetails[index].contactPhone == '' ? 'Proszę uzupełnić pole' : 'Prosze poprawić pole'}
                            </div>
                        </div>
                        <div className={`m-form__field ${valData.contactDetails[index].contactEmail == false ? 'is--error' : ''}`}>
                            <label className="with-tooltip">E-mail</label>
                            <div className="m-form__component">
                                <input
                                    type='email'
                                    placeholder=""
                                    data-pattern="[\w-\.]+@([\w-]+\.)+[\w-]{2,4}"
                                    data-required
                                    // name={contact}
                                    value={contact.contactEmail}
                                    onChange={(e) => {
                                        inputChange('contactDetails', e.target.value, index, 'contactEmail');
                                    }}
                                    onBlur={(e) => {
                                        inputBlur(e.target, 'contactDetails', index, 'contactEmail');
                                    }}
                                />
                            </div>
                            <div className="m-form__component-error">
                                {outputData.contactDetails[index].contactEmail == '' ? 'Proszę uzupełnić pole' : 'Prosze poprawić pole'}
                            </div>
                        </div>
                    </div>
                )
                )}
                {outputData.contactDetails.length < 2 && <button type="button" className="m-form__btn m-form__btn--light" onClick={addContact} ><span>+ Dodaj kolejną osobę</span> (opcjonalnie)</button>}
                {outputData.contactDetails.length > 1 && <button type="button" className="m-form__btn m-form__btn--light" onClick={removeContact} ><span>- Usuń ostatnią osobę</span></button>}
            </div>

            <div className="m-form__btns">
                <button type="submit" className="m-form__btn m-form__btn--next" disabled={!isValid}>Przejdź dalej</button>
                <button type="button" className="m-form__btn m-form__btn--back" onClick={() => { nextStep(1) }}>Powrót</button>
            </div>
        </form>

    </div>
}

